import axios from 'axios';

export const TOKEN_KEY = 'bond_portal_token';

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/portal` });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    const url = e.config?.url || '';
    if (e.response?.status === 401 && localStorage.getItem(TOKEN_KEY) && !url.startsWith('/auth/login') && !url.startsWith('/auth/mfa')) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = '/portal/login';
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || 'Si è verificato un errore. Riprova.';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === 'string' ? x.msg : JSON.stringify(x))).join(' ');
  return d.msg || String(d);
}

export const eur = (cents) =>
  new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100);

export const money = (v, cur = 'EUR') =>
  v == null || v === '' ? '—' : new Intl.NumberFormat('it-IT', { style: 'currency', currency: cur || 'EUR', maximumFractionDigits: 0 }).format(Number(v));

export const fmtDate = (s) => { const d = s ? new Date(s) : null; return !d ? '—' : Number.isNaN(d.getTime()) ? String(s) : d.toLocaleDateString('it-IT'); };
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'short' }) : '—');

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: 'blob' });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
